import FormData from 'form-data';
import { CALL_API } from 'redux-api-middleware';
import { TOMCAT_URL } from 'src/common/index';
import { CSRF_TOKEN_HEADER } from 'src/actions/api/api';
import { getCsrfTokenSync } from 'src/actions/api/csrf';

export const DOCUMENTS_REQUEST = 'DOCUMENTS_REQUEST';
export const DOCUMENTS_SUCCESS = 'DOCUMENTS_SUCCESS';
export const DOCUMENTS_FAILURE = 'DOCUMENTS_FAILURE';

export function upload(files) {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));

    const config = {};
    config.endpoint = `${TOMCAT_URL}api/documents/upload`;
    config.method = 'POST';
    config.credentials = 'include';
    config.body = formData;
    config.headers = {
        [CSRF_TOKEN_HEADER]: getCsrfTokenSync(),
    };

    console.log(config.method, config.endpoint);

    return dispatch => {
        return dispatch({
            [CALL_API]: {
                ...config,
                types: [DOCUMENTS_REQUEST, DOCUMENTS_SUCCESS, DOCUMENTS_FAILURE],
            },
        });
    };
}
